<template>
  <div class="py-10">
    <div style="margin:0 10%;">
      <h1>วิสัยทัศน์ด้านการศึกษาวิจัย</h1>
      <v-card color="primary" class="mt-3" tile style="height:8px; width:150px;"></v-card>
    </div>
    <div style="margin:0 10%;">
      <v-row class="px-2">
        <v-col cols="12" md="12" class="px-3">
          <h1 class="py-4 header-vision">วิสัยทัศน์</h1>
          <v-hover v-slot:default="{ hover }">
            <v-card
              :class="
                hover
                  ? 'pa-2 px-8 animate__animated animate__pulse elevation-10 '
                  : 'pa-2 px-8'
              "
              :style="hover ? '' : ' box-shadow: 0px 10px #51d0de;'"
            >
              <p class="font-weight-bold pt-5 text_p black--text">{{ all_vision[3].vision }}</p>
            </v-card>
          </v-hover>
          <h1 class="py-3 pt-7 header-vision">พันธกิจ</h1>
          <v-hover v-slot:default="{ hover }">
            <v-card
              :class="
                hover
                  ? 'animate__animated animate__pulse elevation-10 py-6 mt-2 px-4'
                  : 'py-6 mt-2 px-4'
              "
              :style="hover ? '' : ' box-shadow: 0px 10px #bf4aa8;'"
            >
              <v-list-item
                class="icon-mission-list"
                v-for="(mission, i) in all_vision[3].missions.data"
                :key="i"
              >
                <v-list-item-icon>
                  <v-icon small color="#bf4aa8">mdi-radiobox-marked</v-icon>
                </v-list-item-icon>
                <v-list-item-content class="font-weight-bold text_p black--text">{{ mission }}</v-list-item-content>
              </v-list-item>
            </v-card>
          </v-hover>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      all_vision: [],
      // vision:
      //   "เป็นศูนย์กลางการศึกษาและฝึกอบรมทางวิสัญญีวิทยาที่มีมาตรฐานสากลโดยผลิตบุคลากรทางวิสัญญีวิทยาที่มีความรู้ ความสามารถ และมีคุณธรรมเป็นที่ยอมรับและแข่งขันได้ในระดับสากล",
      // mission: [
      //   {
      //     id: 0,
      //     mission_data:
      //       "ผลิตและพัฒนาแพทย์ผู้เชี่ยวชาญเฉพาะทางวิสัญญีวิทยา และบุคลากรทางด้านวิสัญญีที่มีความรู้ ความสามารถ โดยยึดตามมาตรฐานความปลอดภัยของผู้ป่วย และเป็นที่ยอมรับในระดับสากล"
      //   },
      //   {
      //     id: 1,
      //     mission_data:
      //       "ผลิตเละพัฒนาเเพทย์ผู้เชี่ยวชาญเฉพาะทางวิสัญญีวิทยา และบุคลากรทางด้านวิสัญญีที่มีคุณธรรมและจริยธรรมอันดี เหมาะสมกับจรรยาบรรณวิชาชีพ"
      //   },
      //   {
      //     id: 2,
      //     mission_data:
      //       "สนับสนุนการจัดการเรียนการสอนให้สอดคล้องกับมาตรฐานของสำนักงานคณะกรรมการอุดมศึกษา(สกอ.) แพทยสภา และราชวิทยาลัยวิสัญญีแพทย์แห่งประเทศไทย (รววท.)"
      //   },
      //   {
      //     id: 3,
      //     mission_data:
      //       "บูรณาการด้านการเรียนการสอน การบริการ และการวิจัยให้มีประสิทธิภาพสูงสุด"
      //   }
      // ]
    };
  },
  watch: {},
  created() {
    this.getVision();
  },
  methods: {
    getVision() {
      let vision = [];
      this.axios
        .get(process.env.VUE_APP_API + "/api/v1/vision")
        .then((response) => {
          // console.log(response.data);
          vision = response.data;

          this.all_vision = vision;
        });
    },
  },
};
</script>
